import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-rider',
  imports: [],
  templateUrl: './rider.html',
  styleUrl: './rider.css',
})
export class Rider {
  protected readonly riderUrl = environment.riderUrl;
}
